module.exports = __webpack_public_path__ + "static/media/LevelUpgradeSilver.e1d1447a.png";